import React, {useState} from 'react';
import Button from 'components/_UI/Button';
import Fieldset from 'components/_UI/Fieldset';
import Text from 'components/_UI/Text';
import { useStepRegister } from 'context/login/StepRegister';
import { useUser } from 'context/user/User';
import masks from 'helpers/masks';
import { Column } from 'styled/alignment/Column';
import { StyledForm } from 'styled/UI/StyledForm';
import colors from 'theme/colors';
import sizes from 'theme/sizes';
import { useForm } from 'react-hook-form';
import { HorizontalCenter } from 'styled/alignment/Center';
import fieldValidations from 'helpers/fieldValidations';
import date from 'helpers/date';
import buttonText from 'texts/buttons/buttonText';
import step from 'helpers/system/step';
import paths from 'routes/paths';

function RegisterStepOne() {
    
    const { stepRegister, setStepRegister } = useStepRegister();
    const { user, setUser } = useUser();
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: {
            firstName: user.first_name || '',
            lastName: user.last_name || '',
            birthdate: user.birthdate ? date.format(user.birthdate) : ''
        }
    });

    const nextStep = ({ firstName, lastName, birthdate }) => {
        setUser({
            ...user,
            first_name: firstName,
            last_name: lastName,
            birthdate: date.unformat(birthdate)
        });
        setStepRegister(step.next(stepRegister))
    };

    return (
        <>
            <Column verticalCenter>
                <Text color={colors.neutral} type='bold' name='highlight'>Para começarmos,</Text>
                <Text color={colors.neutral} type='bold' name='highlight'>qual seu nome e data de nascimento?</Text>
            </Column>

            <StyledForm
                marginTop={sizes.normal}
                paddingRight='13%'
                paddingLeft='13%'
                onSubmit={handleSubmit(nextStep)}
            >
                <Fieldset
                    placeholder='nome *'
                    layout='straight-center'
                    marginTop={sizes.normal}
                    name="firstName"
                    register={register}
                    validations={fieldValidations.name()}
                />
                <HorizontalCenter>
                    <Text color={colors.danger}> {errors.firstName?.message} </Text>
                </HorizontalCenter>

                <Fieldset
                    placeholder='sobrenome *'
                    layout='straight-center'
                    marginTop={sizes.normal}
                    name="lastName"
                    register={register}
                    validations={fieldValidations.name('sobrenome')}
                />

                <HorizontalCenter>
                    <Text color={colors.danger}> {errors.lastName?.message} </Text>
                </HorizontalCenter>

                <Fieldset
                    placeholder='data de nascimento *'
                    layout='straight-center'
                    marginTop={sizes.normal}
                    mask={masks.date}
                    name="birthdate"
                    register={register}
                    validations={fieldValidations.date()}
                />

                <HorizontalCenter>
                    <Text color={colors.danger}> {errors.birthdate?.message} </Text>
                </HorizontalCenter>

                <Button
                    category='roundedBorded'
                    variant='secondary'
                    size='large'
                    marginTop={sizes.big}
                    type='submit'
                >
                    {buttonText.next}
                </Button>

                <Button           
                    path={paths.login}
                    category='minimal'
                    variant='primary'
                    size='large'
                    marginTop={sizes.nano}
                >
                    {buttonText.back}
                </Button>
            </StyledForm>
        </>
    )
};

export default RegisterStepOne;